import React from "react"
import ArticlePage from "@Screens/Knowledge/Articles/ArticlesPage"
import { useRecoilValue } from "recoil"
import { allAxisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { AXIS } from "@Constants/constant"

const Medical = (props) => {
    const { navigation } = props
    const allAxis = useRecoilValue(allAxisAtom)
    const currentAxis = allAxis.filter((item) => item.name === AXIS.MEDICAL)
    return (
        <ArticlePage navigation={navigation} axisId={currentAxis && currentAxis.length > 0 ? currentAxis[0]?.id : -1} />
    )
}

export default Medical
